import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import FileWebSocketClient from "@/utils/websocket/FileWebSocketClient";
import { MessageType, ProgressEventType, WSFileUploadResponse } from "@/utils/websocket/filews/WSFileUploadTypes";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

export type FileProgressMap<bytesReceived = number> = {
  [fname: string]: bytesReceived;
};

const ws = FileWebSocketClient;

// Such bullshit to maintain state in react
function useFileUploadProgress() {
  const [fileProgressMap, setFileProgressMap] = useState<FileProgressMap>({});
  const [files, setFiles] = useState<File[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  function resetFileProgressMap() {
    setFileProgressMap({});
  }

  /**
   * @param r string representing the File WebSocket event response
   */
  function wsFileUploadCallback(r: string) {
    const data: WSFileUploadResponse = JSON.parse(r);
    if (data.content.messageType !== MessageType.UPLOAD_PROGRESS) return;
    handleWSFileUploadEvent(setFileProgressMap, setFiles, setUploadedFiles, data);
  }

  const currentUser = AuthService.getUser();

  useEffect(() => {
    if (ws) {
      ws.subscribeRaw(currentUser.externalId, (m) => {
        wsFileUploadCallback(m.body);
      });
    }
  }, [files, fileProgressMap, uploadedFiles]);

  // Pass down set functions to maintain previous state
  function handleWSFileUploadEvent(
    setFileProgressMap: Dispatch<SetStateAction<FileProgressMap>>,
    setFiles: Dispatch<SetStateAction<File[]>>,
    setUploadedFiles: Dispatch<SetStateAction<File[]>>,
    data: WSFileUploadResponse
  ) {
    const fname = data.content.filename;
    switch (data.content.event) {
      case ProgressEventType.TRANSFER_STARTED_EVENT: {
        setFileProgressMap((prev) => {
          if (prev[fname] === undefined) {
            prev[fname] = 0;
          }
          return { ...prev };
        });
        break;
      }
      case ProgressEventType.REQUEST_BYTE_TRANSFER_EVENT: {
        setFileProgressMap((prev) => {
          prev[fname] += data.content.transferred;
          return { ...prev };
        });
        break;
      }
      case ProgressEventType.TRANSFER_COMPLETED_EVENT: {
        setFiles((prevFiles) => {
          setUploadedFiles((prevUploadedFiles) => [...prevUploadedFiles, ...prevFiles.filter((f) => f.name === fname)]);
          return prevFiles.filter((f) => f.name !== fname);
        });
        break;
      }
      default: {
        break;
      }
    }
  }

  function resetState() {
    setFiles([]);
    setUploadedFiles([]);
    resetFileProgressMap();
  }

  return {
    resetFileProgressMap,
    files,
    setFiles,
    uploadedFiles,
    resetState,
    fileProgressMap,
  };
}

export default useFileUploadProgress;
